<template>
  <div class="flex font-medium text-gray-700 pb-2">
    <div v-for="(action, index) in actions" :key="index">
      <input
        :class="{
          'ml-2': index > 0,
        }"
        type="radio"
        :id="action.identifier"
        name="type"
        :value="action.identifier"
        :checked="action.default"
        @click="$emit('click-handler', $event.target.value)"
      />
      <label class="ml-1" :for="action.identifier">{{ action.label }}</label>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdjustmentRadio",
  data() {
    return {};
  },
  props: {
    type: {
      type: String,
      default: "Discount",
    },
  },
  computed: {
    actions() {
      return [
        {
          identifier: "order",
          default: true,
          label: `Order ${this.type}`,
        },
      ];
    },
  },
  created() {},
};
</script>
